
export const FOREVER_FELINE_SNAP = {
      description: "This pilot program is a partnership between Boehringer Ingelheim and IDEXX to offer a cat owner a rebate of $25 when they test and vaccinate their cat for FeLV. For more information, please refer to the",
      pdf: "https://cdn.greenlinepet.com/images/offerenrollment/forever_feline_snap.pdf"
  };

export const FOREVER_FELINE_CHEM = {
      description: "This pilot program is a partnership between Boehringer Ingelheim and IDEXX to offer a cat owner a rebate of $25  when they get an IDEXX Chem 10/15/17 panel. For more information, please refer to the",
      pdf: "https://cdn.greenlinepet.com/images/offerenrollment/forever_feline_chem.pdf"
  };
